import { create } from "zustand";

export const usePotreeStore = create((set, get) => ({
  potreeViewer: null,
  setPotreeViewer: (viewer) => set({ potreeViewer: viewer }),
  editMode: false,
  setEditMode: (mode) => set({ editMode: mode }),
  selectedPointMode: true,
  setSelectedPointMode: (mode) => set({ selectedPointMode: mode }),
  selectedStartingPoint: null,
  setSelectedStartingPoint: (point) => set({ selectedStartingPoint: point }),
}));

export const PotreeGenerateAreaStore = create((set, get) => ({
  IsStartAreaGenerate: false,
  setIsStartAreaGenerate: (mode) => set({ IsStartAreaGenerate: mode }),
  pathMode: "X-Turn",
  setPathMode: (mode) => set({ pathMode: mode }),
  direction: "X",
  setDirection: (direction) => set({ direction: direction }),

  // 회전/헤드랜드 여유(m). 값을 줄이면 헤드랜드 폭이 감소하여 커버율은 올라가지만
  // 실제 장비 회전에 필요한 안전 여유가 부족해질 수 있으니 현장 조건에 맞게 조절하세요.
  safetyMargin: 0.1,
  setSafetyMargin: (m) => set({ safetyMargin: Number(m) }),

  gradientCover: null,
  setGradientCover: (func) => set({ gradientCover: func }),

  elevationRangeOffset: 4,
  setElevationRangeOffset: (offset) => set({ elevationRangeOffset: offset }),

  minZ: 0,
  setMinZ: (z) => set({ minZ: z }),

  isPathGenerated: false,
  setIsPathGenerated: (flag) => set({ isPathGenerated: flag }),
}));

export const AutovehicleSpecsStore = create((set, get) => ({
  AutovehicleSpecs: {
    1: {
      name: "대동 HX1400-A",
      wheelBase: 2.2,
      steeringAngle: 35,
      vehicleLength: 4.3,
      width: 2.1,
      turningRadius: 4.0,
    },
    2: {
      name: "LS엠트론 MT9",
      wheelBase: 2.25,
      steeringAngle: 35,
      vehicleLength: 4.4,
      width: 2.1,
      turningRadius: 4.1,
    },
    3: {
      name: "사용자 입력",
      wheelBase: 0,
      steeringAngle: 0,
      vehicleLength: 0,
      width: 0,
      turningRadius: 0,
    },
  },

  // 기계 스펙 선택
  selectedAutovehicleSpecs: 1,
  setSelectedAutovehicleSpecs: (specs) =>
    set({ selectedAutovehicleSpecs: specs }),

  updateUserSpecs: (field, value) => {
    const currentSpecs = get().AutovehicleSpecs;
    set({
      AutovehicleSpecs: {
        ...currentSpecs,
        3: { ...currentSpecs[3], [field]: parseFloat(value) || 0 },
      },
    });
  },

  resetUserSpecs: () => {
    const currentSpecs = get().AutovehicleSpecs;
    set({
      AutovehicleSpecs: {
        ...currentSpecs,
        3: {
          ...currentSpecs[3],
          wheelBase: 0,
          steeringAngle: 0,
          vehicleLength: 0,
          width: 0,
          turningRadius: 0,
        },
      },
    });
  },

  interval: 0.2,
  size: 0.1,
  setInterval: (interval) => set({ interval: interval }),
  setSize: (size) => set({ size: size }),

  WorkMode: "ridge",
  setWorkMode: (mode) => set({ WorkMode: mode }),

  seedPosition: [],
  setSeedPosition: (position) => set({ seedPosition: position }),
}));

export const usePathModeStore = create((set, get) => ({
  SelectionGenerateMode: "auto",
  setSelectionGenerateMode: (mode) => set({ SelectionGenerateMode: mode }),

  bezierCurves: [],
  setBezierCurves: (curves) => set({ bezierCurves: curves }),

  fullPathStore: null,
  setFullPathStore: (path) => set({ fullPathStore: path }),
}));

// 영역/경로 정보 모달(전역) 상태
export const usePathInfoModalStore = create((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

// 마지막 영역(측정) 결과를 전역으로 보관
// - PathRemove_Create.js에서 scene.measurements를 비워도 모달에서 항상 표시 가능
export const useLastAreaMeasurementStore = create((set) => ({
  lastAreaMeasurement: null, // { name: string, points: Array<{x,y,z?}>, area_m2: number, areaLabelText: string }
  setLastAreaMeasurement: (payload) => set({ lastAreaMeasurement: payload }),
  clearLastAreaMeasurement: () => set({ lastAreaMeasurement: null }),
}));

// 헤드랜드 및 작업 영역 데이터를 전역으로 보관 (다운로드용)
export const useHeadlandWorkAreaStore = create((set) => ({
  headlandData: null, // { headland: Array<[x,y]>, work_area: Array<[x,y]>, turning: Array<[x,y]> }
  workAreaPolygon: null, // Array<[x,y]> - 작업 영역 폴리곤 좌표
  setHeadlandData: (data) => set({ headlandData: data }),
  setWorkAreaPolygon: (polygon) => set({ workAreaPolygon: polygon }),
  clearHeadlandWorkArea: () =>
    set({ headlandData: null, workAreaPolygon: null }),
}));
